"use strict";
exports.__esModule = true;
exports.determineMessageFromFilter = void 0;
function determineMessageFromFilter(filterTypes) {
    if (filterTypes == null || filterTypes.length !== 1) {
        return "Type anything, search everywhere";
    }
    var filterType = filterTypes[0];
    switch (filterType) {
        case "person":
            return "Type to search tasks";
        case "person":
            return "Type to search people";
        default:
            return "Type anything, search everywhere";
    }
}
exports.determineMessageFromFilter = determineMessageFromFilter;
